import { DataSource, Layout, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutRenditionRuleProfiles extends Layout {
    sourceImapCats: DataSource;
    sourceRenditionRuleProfiles: DataSource;
    table1: Table;
    tbRulepExpression: Textbox;
    tbRulepId: Textbox;
    textboxOperatos: Textbox;
}
